/**
 * Counts down to the moment in `data-end` and writes hh:mm:ss into the pill
 * every second. At zero it marks the surrounding deal of the day as over, or
 * hides itself when it stands alone.
 */
const two = (number) => String(number).padStart(2, '0');

class CountDown extends HTMLElement {
  #end;
  #timer;
  #calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  connectedCallback() {
    this.#end = Date.parse(this.dataset.end);
    if (Number.isNaN(this.#end)) return;

    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const left = Math.max(0, Math.floor((this.#end - Date.now()) / 1000));
    const hours = Math.floor(left / 3600);
    const minutes = Math.floor((left % 3600) / 60);
    const time = this.querySelector('[data-time]');
    const text = `${time.dataset.prefix} ${two(hours)}:${two(minutes)}${this.#calm ? '' : `:${two(left % 60)}`}`;

    if (time.textContent !== text) time.textContent = text;
    this.ariaLabel = this.dataset.label.replace('[hours]', hours).replace('[minutes]', minutes);

    if (left > 0) return;

    clearInterval(this.#timer);
    const deal = this.closest('[data-day-deal]');
    if (deal) deal.classList.add('is-over');
    else this.hidden = true;
  }
}

if (!customElements.get('count-down')) customElements.define('count-down', CountDown);
